import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, X } from "lucide-react";

const KEY = "pandax_meet_safety_dismissed_v1";

export default function SocialMeetSafetyNotice() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(KEY) === "1");
  if (dismissed) {
    return (
      <div className="flex items-center gap-3 text-[11px] text-zinc-500 mb-3" data-testid="social-meet-safety-compact">
        <button type="button" onClick={() => { localStorage.removeItem(KEY); setDismissed(false); }} className="inline-flex items-center gap-1 hover:text-white" data-testid="social-meet-safety-reopen"><ShieldAlert size={12} /> Meeting safety</button>
        <span>·</span>
        <Link to="/legal/privacy-policy" className="hover:text-white underline underline-offset-2" data-testid="social-meet-privacy-link">Privacy Policy</Link>
      </div>
    );
  }
  return (
    <div className="border border-amber-500/30 bg-amber-500/[0.06] px-4 py-3 mb-4 flex items-start gap-3" data-testid="social-meet-safety-notice">
      <ShieldAlert size={18} className="text-amber-400 shrink-0 mt-0.5" />
      <div className="text-xs text-zinc-300 leading-relaxed">
        <span className="font-medium text-white">Meeting someone in person?</span> Meet in a public place, tell a friend where you&apos;re going, keep your own transport, and never share your home address or financial details. You appear as &quot;nearby&quot; only after you check in, and you can check out anytime. Report or block anyone who makes you uncomfortable — we act within 24 hours.{" "}
        <Link to="/legal/privacy-policy" className="underline text-rose-300 hover:text-rose-200" data-testid="social-meet-privacy-link">Privacy Policy</Link>
      </div>
      <button type="button" onClick={() => { localStorage.setItem(KEY, "1"); setDismissed(true); }} className="text-zinc-500 hover:text-white shrink-0" aria-label="Dismiss" data-testid="social-meet-safety-dismiss"><X size={14} /></button>
    </div>
  );
}
